import service from './index'

const resource = service.resource('liverun-settings/update')
const getResources = service.resource('liverun-settings/all')
export default {
  update (body) {
    return resource.update(body)
  },
  get () {
    return getResources.get()
  }
}




// WEBPACK FOOTER //
// ./src/services/settings.js